import * as React from 'react';
import { enforceFromRolePermissions } from '@authe/fe-commons/auth';
import { jsx } from 'react/jsx-runtime';

// src/permissions/PermissionProvider.tsx
var PermissionContext = React.createContext(null);
function PermissionProvider({
  children,
  permissions,
  rolePermissions,
  can,
  isLoading = false
}) {
  const value = React.useMemo(() => {
    const check = can ?? (permissions ? (resource, action) => permissions.can(resource, action) : (resource, action) => enforceFromRolePermissions(rolePermissions, resource, action));
    return { can: check, isLoading };
  }, [can, permissions, rolePermissions, isLoading]);
  return /* @__PURE__ */ jsx(PermissionContext.Provider, { value, children });
}
function usePermissions() {
  return React.useContext(PermissionContext) ?? { can: () => false, isLoading: false };
}
function usePermission(resource, action) {
  return usePermissions().can(resource, action);
}

export { PermissionProvider, usePermission, usePermissions };
//# sourceMappingURL=chunk-JNMH5O4E.js.map
//# sourceMappingURL=chunk-JNMH5O4E.js.map